let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drI9i")).then(() => parcelRequire('piTsY'));